type Primitive = string | number | boolean;

export function areAllValid(...args: any[]): boolean {
  return args.every(arg => isValid(arg));
}

export function areAnyValid(...args: any[]): boolean {
  return args.some(arg => isValid(arg));
}

export function assert(condition: boolean, message?: string): void {
  condition || console.error('ASSERT FAILED - :' + message);
}

export function isValid<T>(arg: T): boolean {
  return arg !== undefined && arg !== null;
}

export function makeDistinct<T extends Primitive>(array: T[]): T[] {
  return array.filter((value, index, self) => self.indexOf(value) === index);
}
